import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ShowTickerComponent } from '@core/components/show-ticker/show-ticker.component';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';

import { NgMarqueeModule } from 'ng-marquee';
import { ManageTickerService } from '@core/components/show-ticker/show-ticker.service';
import { UtilsPipeModule } from '@core/pipes/utils-pipe';

/** pipes */
import { MXCurrencyPipe } from "@core/pipes/utils-pipe";


@NgModule({
  declarations: [ShowTickerComponent],
  providers: [ManageTickerService, MXCurrencyPipe],
  imports: [
    MatIconModule,
    CommonModule,
    NgMarqueeModule,
    MatDividerModule,
    UtilsPipeModule
  ],
  exports: [ShowTickerComponent]
})
export class ShowIndexesModule { }

